import { Api } from '../../../utility/client';

export async function stopDemoSession() {
  return Api.post('/v1/vbase/demo/stop');
}
